import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PoTableColumn } from "@po-ui/ng-components";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: "root"
})
export class ClientesListService {
  //Meu Ambiente esta local, esta URL deve ser alterada para seu ERP
  url = `${environment.API}clientes`
  constructor(private http: HttpClient) {}

  getclientessList(filtro: String): Observable<any> {
    return this.http.post(this.url, {
      filter: filtro
    });
  }

  getColumns(): Array<PoTableColumn> {
    return [
      { property: "codigo", label: "Código", width:"8%" },
      { property: "loja", label: "Loja",  width:"8%" },
      { property: "nome", label: "Nome", width:"20%" },
      { property: "ddd", label: "DDD",  width:"8%" },
      { property: "telefone", label: "Telefone", width:"10%" },
      { property: "email", label: "E-mail", type: "link", width:"20%" },
      { property: "status",label: "Situação", width:"10%"}
    ];
  }
}
